export class Dom {


    static init() {
        this.ua = (function (u) {
            return {
                Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
                || u.indexOf("ipad") != -1
                || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
                || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
                || u.indexOf("kindle") != -1
                || u.indexOf("silk") != -1
                || u.indexOf("playbook") != -1,
                Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
                || u.indexOf("iphone") != -1
                || u.indexOf("ipod") != -1
                || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
                || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
                || u.indexOf("blackberry") != -1,
                Android: (u.indexOf("android") != -1),
                iPhone: (u.indexOf("iphone") != -1),
                winfirefox: ((u.indexOf('firefox') != -1) && (u.indexOf('mac') == -1)),
                ie11: (u.indexOf('trident') !== -1)
            }
        })(window.navigator.userAgent.toLowerCase());

        this.win = $(window);
        this.doc = $(document);
        this.body = $('html,body');
        this.width = this.win.width();
        this.height = this.win.height();
        if (Dom.ua.ie11) {
            Dom.body.addClass('ie11');
        }
        if (Dom.ua.iPhone) {
            Dom.body.addClass('ua-iphone');
        }
        if (Dom.ua.Android) {
            Dom.body.addClass('ua-android');
        }
        if (Dom.ua.Tablet) {
            Dom.body.addClass('ua-tablet');
        }


        this.win.scroll((e) => {
            let scroll = this.win.scrollTop();
            if (scroll > 700) {
                this.body.addClass('scroll');
            } else {
                this.body.removeClass('scroll');
            }
        }).trigger('scroll');
    }
}
